export enum SettingsActionTypes {
    START_REQUEST = 'SETTINGS_START_REQUEST',
    END_REQUEST = 'SETTINGS_END_REQUEST',
    LOAD_SUCCESS = 'SETTINGS_LOAD_SUCCESS',
    LOAD_ERROR = 'SETTINGS_LOAD_ERROR',
    RESET = 'SETTINGS_RESET'
}
